<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" labelString="商品" ></goodsSearchItem>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>

      <div slot="table">
        <div class="btns">
          <DownloadButton  @on-click="handleExport" v-if="handlePermission('drugRankExport')" ></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
export default {
  name: 'DrugRank',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: false,
      params: {
        storeIdList: [], // 门店
        nameMix: '', // 商品名称
      },
      query: {
        storeIdList: [], // 门店
        nameMix: '', // 商品名称
      },
      columns: [
        { title: '近一年销售额排名', key: 'orderRank', minWidth: 90 },
        { title: '门店', key: 'storeName', minWidth: 156 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '生产企业', key: 'producer', minWidth: 116 },
        { title: '单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '进项税率	', key: 'inputTaxRateStr', minWidth: 116 },
        { title: '销项税率	', key: 'outputTaxRateStr', minWidth: 116 },
        { title: '年度含税毛利率', key: 'annualGpm', minWidth: 126 },
        { title: '年度不含税毛利率', key: 'annualGpmWithoutTax', minWidth: 136 },
        { title: '本月销量', key: 'saleNum', minWidth: 116 },
        { title: '本月不含税销售额', key: 'saleAmountWitoutTax', minWidth: 136 },
        { title: '上月同期销量', key: 'lastMonthSameSaleNum', minWidth: 116 },
        { title: '同期销量环比', key: 'salesVolumeStr', minWidth: 116 },
        { title: '上月同期不含税销售额', key: 'lastMonthSameSaleAmountWithoutTax', minWidth: 156 },
        { title: '同期销售额环比', key: 'saleAmountWithoutTaxVolumeStr', minWidth: 126 },
        { title: '上月总销量', key: 'lastMonthTotalNum', minWidth: 116 },
        { title: '上月总不含税销售额', key: 'lastMonthAmountWithoutTax', minWidth: 146 },
        { title: '本月购药人数', key: 'buyerNum', minWidth: 116 },
        { title: '上月同期购药人数', key: 'lastMonthSameBuyerNum', minWidth: 136 },
        { title: '购药人数同期环比', key: 'buyerNumVolumeStr', minWidth: 136 },
        { title: '上月购药人数', key: 'lastMonthBuyerNum', minWidth: 116 },
        { title: '当前可销售库存', key: 'iventorySaleNum', minWidth: 126 },
        {
          title: '最近近效期时间',
          key: 'minExpiryDate',
          minWidth: 126,
          render: (h, { row }) => h('span', utils.exchangeTime(row.minExpiryDate)),
        },
        { title: '最近近效期数量', key: 'minExpiryDateNum', minWidth: 126 },
      ],
      tableData: [],
    };
  },
  methods: {
    handleExport() { // 导出
      const temp = utils.deepClone(this.params);
      delete temp.page;
      delete temp.size;
      temp.queryCondition = utils.getQueryCondition('.queryContainer');
      reportService.drugRankExport(temp).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      reportService.drugRank(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        storeIdList: [],
        nameMix: '',
      };
    },
  },
  mounted() {
    this.handleSearch(true);
    // if (this.roleType !== 2) {
    //   this.columns.splice(0, 0, { title: '门店名称', key: 'saleRecallPlanStoreName', minWidth: 116 });
    // }
  },
  components: {
    QueryFrame,
    DownloadButton,
  },
};
</script>

  <style scoped>
  .btns{
    margin-bottom: 12px
  }
  </style>
